<script setup>
import { onMounted } from 'vue';

import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';
import TeamTable from './overview/TeamTable.vue';

const store = useStore();

const uiFlags = useMapGetter('getOverviewUIFlags');
const teamConversationMetric = useMapGetter('getTeamConversationMetric');
const teams = useMapGetter('teams/getTeams');

const fetchData = () => store.dispatch('fetchTeamConversationMetric');

const { startRefetching } = useLiveRefresh(fetchData);

onMounted(() => {
  store.dispatch('teams/get');
  fetchData();
  startRefetching();
});
</script>

<template>
  <div class="w-full max-w-full">
    <div class="flex flex-col m-0.5 px-3 py-4 sm:px-2 sm:py-3 md:px-4 md:py-5 rounded-xl text-n-slate-12 shadow outline-1 outline outline-n-container bg-n-solid-2 w-full">
      <div class="card-header flex flex-col gap-2 sm:gap-1.5 md:gap-3 md:w-full md:mb-4 lg:mb-6">
        <div class="flex items-center gap-2 flex-row">
          <h5 class="mb-0 text-n-slate-12 font-medium text-sm sm:text-sm md:text-base lg:text-lg leading-tight">
            {{ $t('OVERVIEW_REPORTS.TEAM_CONVERSATIONS.HEADER') }}
          </h5>
          <span class="flex flex-row items-center py-0.5 px-1.5 sm:px-2 rounded bg-n-teal-3 text-xs">
            <span class="bg-n-teal-9 h-1 w-1 rounded-full mr-1 rtl:mr-0 rtl:ml-0"></span>
            <span class="text-xs text-n-teal-11">
              {{ $t('OVERVIEW_REPORTS.LIVE') }}
            </span>
          </span>
        </div>
      </div>
      <div class="card-body w-full">
        <TeamTable
          :teams="teams"
          :team-metrics="teamConversationMetric"
          :is-loading="uiFlags.isFetchingTeamConversationMetric"
        />
      </div>
    </div>
  </div>
</template>
